
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { createMotionProxy } from './motion-proxy.mjs.js';
import { createDomMotionConfig } from './utils/create-config.mjs.js';

/**
 * @public
 */
var m = createMotionProxy(createDomMotionConfig);

export { m };
//# sourceMappingURL=motion-minimal.mjs.js.map
